import { coordinateStringToObj } from '../utils/map/turf-utils';
import { CoordinateInterface } from './locations-models/coordinate-interface';

// TODO: Remove this after refactoring base map and map utils

export class Coordinate implements CoordinateInterface {
  latitude?: number;
  longitude?: number;

  constructor(coordinates: string) {
    if (typeof coordinates !== 'string') {
      console.error('coordinates param is not a string!');
      return;
    }

    const coords = coordinateStringToObj(coordinates);
    this.latitude = coords.latitude;
    this.longitude = coords.longitude;
  }
}